(function () {
  function bindSwipe(target, onSwipe) {
    if (!target || target.dataset.gutSwipeReady === 'true') return;
    target.dataset.gutSwipeReady = 'true';

    let touchStartX = 0;
    let touchStartY = 0;

    target.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    target.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      onSwipe(deltaX > 0 ? -1 : 1);
    }, { passive: true });
  }

  function initLoopingTrackCarousel(config) {
    const {
      carousel,
      track,
      realSlides,
      viewport,
      prev,
      next,
      cloneKey,
      transitionMs = 320,
      autoplayMs = 0,
    } = config;

    let position = realSlides.length > 1 ? 1 : 0;
    let isAnimating = false;
    let fallbackTimer = null;
    let autoplayTimer = null;

    function makeClone(slide) {
      const clone = slide.cloneNode(true);
      clone.dataset[cloneKey] = 'true';
      clone.setAttribute('aria-hidden', 'true');
      return clone;
    }

    if (realSlides.length > 1) {
      track.insertBefore(makeClone(realSlides[realSlides.length - 1]), realSlides[0]);
      track.appendChild(makeClone(realSlides[0]));
    }

    const slides = Array.from(track.children).filter((slide) => slide.hasAttribute('data-gut-mobile-carousel-slide') || slide.hasAttribute('data-gut-auto-carousel-slide'));
    const realCount = realSlides.length;

    function setPosition(nextPosition) {
      position = nextPosition;
      track.style.transform = `translate3d(${-position * 100}%, 0, 0)`;
      slides.forEach((slide, index) => {
        const isCurrent = index === position;
        const isClone = slide.dataset[cloneKey] === 'true';
        slide.setAttribute('aria-hidden', isCurrent && !isClone ? 'false' : 'true');
      });
    }

    function jumpTo(nextPosition) {
      track.style.transition = 'none';
      setPosition(nextPosition);
      track.offsetHeight;
      track.style.transition = '';
    }

    function finishTransition() {
      if (!isAnimating) return;
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;

      if (position === 0) {
        jumpTo(realCount);
      } else if (position === realCount + 1) {
        jumpTo(1);
      } else {
        setPosition(position);
      }

      isAnimating = false;
    }

    function move(direction) {
      if (isAnimating || realCount < 2) return;
      isAnimating = true;
      track.style.transition = '';
      setPosition(position + direction);
      fallbackTimer = window.setTimeout(finishTransition, transitionMs + 80);
    }

    function stopAutoplay() {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (!autoplayMs || realCount < 2 || autoplayTimer) return;
      autoplayTimer = window.setInterval(() => move(1), autoplayMs);
    }

    track.addEventListener('transitionend', (event) => {
      if (event.target === track && event.propertyName === 'transform') {
        finishTransition();
      }
    });

    if (realCount < 2) {
      prev?.setAttribute('hidden', '');
      next?.setAttribute('hidden', '');
      setPosition(0);
    } else {
      jumpTo(position);
    }

    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    bindSwipe(viewport || carousel, move);

    if (autoplayMs) {
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
      startAutoplay();
    }
  }

  function initGallery(gallery) {
    if (gallery.dataset.gutGalleryReady === 'true') return;
    gallery.dataset.gutGalleryReady = 'true';

    const slides = Array.from(gallery.querySelectorAll('[data-gut-slide]'));
    let thumbs = Array.from(gallery.querySelectorAll('[data-gut-thumb]'));
    const prev = gallery.querySelector('[data-gut-prev]');
    const next = gallery.querySelector('[data-gut-next]');
    const thumbRail = thumbs[0]?.parentElement;
    let index = 0;

    if (thumbRail && thumbs.length > 1 && !thumbRail.dataset.gutThumbsLooped) {
      thumbs.forEach((thumb) => {
        const clone = thumb.cloneNode(true);
        clone.classList.add('is-clone');
        clone.tabIndex = -1;
        clone.setAttribute('aria-hidden', 'true');
        thumbRail.appendChild(clone);
      });
      thumbRail.dataset.gutThumbsLooped = 'true';
      thumbs = Array.from(gallery.querySelectorAll('[data-gut-thumb]'));
    }

    function show(nextIndex) {
      if (!slides.length) return;
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-before', slideIndex < index);
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = Number(thumb.dataset.gutThumb) === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive && !thumb.classList.contains('is-clone') ? 'true' : 'false');
      });
      const activeThumb = thumbs.find((thumb) => Number(thumb.dataset.gutThumb) === index && !thumb.classList.contains('is-clone'));
      if (activeThumb && thumbRail) {
        thumbRail.scrollTo({
          left: activeThumb.offsetLeft,
          behavior: 'smooth',
        });
      }
    }

    function go(nextIndex) {
      show(nextIndex);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => go(Number(thumb.dataset.gutThumb)));
    });
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    bindSwipe(gallery.querySelector('.gut-gallery__stage') || gallery, (direction) => go(index + direction));
    show(index);
  }

  function initTestimonials(root) {
    const carousel = root.querySelector('[data-gut-testimonial-carousel]');
    if (!carousel) return;
    if (carousel.dataset.gutTestimonialsReady === 'true') return;
    carousel.dataset.gutTestimonialsReady = 'true';

    const viewport = carousel.querySelector('.gut-testimonial-carousel__viewport');
    if (!viewport) return;
    let track = carousel.querySelector('[data-gut-testimonial-track]');
    if (!track) {
      track = document.createElement('div');
      track.className = 'gut-testimonial-carousel__track';
      track.setAttribute('data-gut-testimonial-track', '');
      Array.from(viewport.children)
        .filter((child) => child.matches('[data-gut-testimonial-slide]'))
        .forEach((slide) => track.appendChild(slide));
      viewport.appendChild(track);
    }

    const realSlides = Array.from(track.querySelectorAll('[data-gut-testimonial-slide]'))
      .filter((slide) => slide.dataset.gutTestimonialClone !== 'true');
    if (!realSlides.length) return;
    const prev = carousel.querySelector('[data-gut-testimonial-prev]');
    const next = carousel.querySelector('[data-gut-testimonial-next]');
    let index = realSlides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;
    let isAnimating = false;
    let fallbackTimer = null;

    function makeClone(slide) {
      const clone = slide.cloneNode(true);
      clone.classList.remove('is-active', 'is-before');
      clone.dataset.gutTestimonialClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      return clone;
    }

    if (realSlides.length > 1) {
      track.insertBefore(makeClone(realSlides[realSlides.length - 1]), realSlides[0]);
      track.appendChild(makeClone(realSlides[0]));
    }

    const slides = Array.from(track.querySelectorAll('[data-gut-testimonial-slide]'));
    const realCount = realSlides.length;
    let position = realCount > 1 ? index + 1 : 0;

    function updateSlides() {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === position;
        const isClone = slide.dataset.gutTestimonialClone === 'true';
        slide.classList.toggle('is-active', isActive);
        slide.classList.toggle('is-before', slideIndex < position);
        slide.setAttribute('aria-hidden', isActive && !isClone ? 'false' : 'true');
      });
    }

    function setPosition(nextPosition) {
      position = nextPosition;
      track.style.transform = `translate3d(${-position * 100}%, 0, 0)`;
    }

    function jumpTo(nextPosition) {
      track.style.transition = 'none';
      setPosition(nextPosition);
      updateSlides();
      track.offsetHeight;
      track.style.transition = '';
    }

    function finishTransition() {
      if (!isAnimating) return;
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;

      if (position === 0) {
        index = realCount - 1;
        jumpTo(realCount);
      } else if (position === realCount + 1) {
        index = 0;
        jumpTo(1);
      } else {
        index = position - 1;
        updateSlides();
      }

      isAnimating = false;
    }

    function show(direction) {
      if (isAnimating || realCount < 2) return;
      isAnimating = true;
      track.style.transition = '';
      setPosition(position + direction);
      updateSlides();
      fallbackTimer = window.setTimeout(finishTransition, 380);
    }

    track.addEventListener('transitionend', (event) => {
      if (event.target === track && event.propertyName === 'transform') {
        finishTransition();
      }
    });

    if (realCount < 2) {
      prev?.setAttribute('hidden', '');
      next?.setAttribute('hidden', '');
      updateSlides();
    } else {
      jumpTo(position);
      window.requestAnimationFrame(() => {
        isAnimating = false;
      });
    }

    prev?.addEventListener('click', () => show(-1));
    next?.addEventListener('click', () => show(1));
    bindSwipe(viewport, show);
  }

  function initCalculator(root) {
    root.querySelectorAll('[data-gut-calculator]').forEach((calculator) => {
      if (calculator.dataset.gutCalculatorReady === 'true') return;
      calculator.dataset.gutCalculatorReady = 'true';

      const weightSlider = calculator.querySelector('[data-gut-calculator-weight]');
      const heightSlider = calculator.querySelector('[data-gut-calculator-height]');
      const weightValue = calculator.querySelector('[data-gut-calculator-weight-value]');
      const heightValue = calculator.querySelector('[data-gut-calculator-height-value]');
      const bmiValue = calculator.querySelector('[data-gut-calculator-bmi]');
      const weightLossAmount = calculator.querySelector('[data-gut-calculator-loss]');
      const bmiWarning = calculator.querySelector('[data-gut-calculator-warning]');
      const viewMoreBtn = calculator.querySelector('[data-gut-calculator-more]');
      const benefitsSection = calculator.querySelector('[data-gut-calculator-benefits]');
      const warningConfigEl = calculator.querySelector('[data-gut-calculator-warnings]');
      let warningConfig = {};

      if (warningConfigEl) {
        try {
          warningConfig = JSON.parse(warningConfigEl.textContent || '{}');
        } catch (error) {
          warningConfig = {};
        }
      }

      if (!weightSlider || !heightSlider || !weightValue || !heightValue || !bmiValue || !weightLossAmount || !bmiWarning) return;

      function inchesToFeetInches(inches) {
        const feet = Math.floor(inches / 12);
        const remainingInches = inches % 12;
        return `${feet}ft ${remainingInches}in`;
      }

      function calculateBMI(weightLbs, heightInches) {
        const bmi = (703 * weightLbs) / (heightInches * heightInches);
        return Math.round(bmi);
      }

      function calculateWeightLoss(weightLbs, bmi) {
        let percentage = 0.10;

        if (bmi >= 35) {
          percentage = 0.14;
        } else if (bmi >= 30) {
          percentage = 0.12;
        } else if (bmi >= 25) {
          percentage = 0.10;
        } else {
          percentage = 0.08;
        }

        return Math.round(weightLbs * percentage);
      }

      function warningIcon(type) {
        if (type === 'check') {
          return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path></svg>';
        }

        if (type === 'circle-alert') {
          return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"></path></svg>';
        }

        return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"></path></svg>';
      }

      function getBMIWarning(bmi) {
        function withConfiguredCopy(key, warning) {
          const configured = warningConfig[key] || {};
          return {
            ...warning,
            title: configured.title || warning.title,
            message: configured.message || warning.message,
          };
        }

        if (bmi < 18.5) {
          return withConfiguredCopy('underweight', {
            className: 'is-underweight',
            icon: warningIcon('triangle'),
            title: 'Underweight Range',
            message: 'Your BMI indicates you may be underweight. Focus on building healthy muscle mass and improving overall nutrition. Consult a healthcare provider before starting any weight loss program.',
          });
        }

        if (bmi >= 18.5 && bmi < 25) {
          return withConfiguredCopy('normal', {
            className: 'is-normal',
            icon: warningIcon('check'),
            title: 'Healthy Weight Range',
            message: 'Great! Your BMI is in the healthy range. Gut Capsule can help you maintain your weight and support overall wellness, energy levels, and gut health.',
          });
        }

        if (bmi >= 25 && bmi < 30) {
          return withConfiguredCopy('overweight', {
            className: 'is-overweight',
            icon: warningIcon('circle-alert'),
            title: 'Overweight Range',
            message: "Your BMI indicates you're in the overweight range. Gut Capsule can help you achieve a healthier weight through improved metabolism, craving control, and balanced blood sugar levels.",
          });
        }

        if (bmi >= 30 && bmi < 35) {
          return withConfiguredCopy('obese', {
            className: 'is-obese',
            icon: warningIcon('triangle'),
            title: 'Obese Range (Class I)',
            message: 'Your BMI indicates obesity. This increases risk for health issues. Gut Capsule can support your weight loss journey alongside a balanced diet and exercise. Consider consulting a healthcare provider for personalized guidance.',
          });
        }

        return withConfiguredCopy('severe', {
          className: 'is-obese',
          icon: warningIcon('triangle'),
          title: 'Obese Range (Class II+)',
          message: 'Your BMI indicates severe obesity, which significantly increases health risks. We strongly recommend consulting with a healthcare provider for a comprehensive weight management plan. Gut Capsule can be part of your journey under medical supervision.',
        });
      }

      function updateCalculations() {
        const weight = parseInt(weightSlider.value, 10);
        const height = parseInt(heightSlider.value, 10);
        const bmi = calculateBMI(weight, height);
        const weightLoss = calculateWeightLoss(weight, bmi);
        const warning = getBMIWarning(bmi);

        weightValue.textContent = `${weight} lbs`;
        heightValue.textContent = inchesToFeetInches(height);
        bmiValue.textContent = bmi;
        weightLossAmount.textContent = `${weightLoss}lbs`;

        bmiWarning.className = `gut-calculator__warning ${warning.className}`;
        bmiWarning.innerHTML = `<div class="gut-calculator__warning-title"><span class="gut-calculator__warning-icon">${warning.icon}</span>${warning.title}</div>${warning.message}`;
      }

      weightSlider.addEventListener('input', updateCalculations);
      heightSlider.addEventListener('input', updateCalculations);

      viewMoreBtn?.addEventListener('click', () => {
        if (!benefitsSection) return;
        benefitsSection.hidden = false;
        viewMoreBtn.hidden = true;
      });

      updateCalculations();
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-gut-faq-list]').forEach((list) => {
      if (list.dataset.gutFaqReady === 'true') return;
      list.dataset.gutFaqReady = 'true';

      const items = Array.from(list.querySelectorAll('[data-gut-faq-item]'));

      function setOpen(item, isOpen) {
        const answer = item.querySelector('[data-gut-faq-answer]');
        item.classList.toggle('is-open', isOpen);
        item.setAttribute('aria-expanded', String(isOpen));
        if (answer) {
          answer.hidden = !isOpen;
        }
      }

      items.forEach((item) => {
        setOpen(item, item.getAttribute('aria-expanded') === 'true');
        item.addEventListener('click', () => {
          const shouldOpen = item.getAttribute('aria-expanded') !== 'true';
          setOpen(item, shouldOpen);
        });
      });
    });
  }

  function initLabel(root) {
    root.querySelectorAll('[data-gut-open-label]').forEach((open) => {
      if (open.dataset.gutLabelOpenReady === 'true') return;
      open.dataset.gutLabelOpenReady = 'true';
      open.addEventListener('click', () => {
        const targetId = open.getAttribute('aria-controls');
        const dialog = targetId ? document.getElementById(targetId) : document.querySelector('[data-gut-label]');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });

    root.querySelectorAll('[data-gut-label]').forEach((dialog) => {
      if (dialog.dataset.gutLabelReady === 'true') return;
      const close = dialog.querySelector('[data-gut-close-label]');
      if (!close) return;
      dialog.dataset.gutLabelReady = 'true';
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  function initBatch(root) {
    if (root.dataset.gutBatchReady === 'true') return;
    root.dataset.gutBatchReady = 'true';
    const dateEls = root.querySelectorAll('[data-gut-batch-date]');
    if (!dateEls.length) return;

    dateEls.forEach((dateEl) => {
      const offset = Number(dateEl.dataset.gutBatchOffset) || 0;
      const date = new Date();
      date.setDate(date.getDate() + offset);
      const day = date.getDate();
      const suffix = day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th';
      dateEl.textContent = `${date.toLocaleDateString('en-US', { month: 'long' })} ${day}${suffix}`;
    });
  }

  function initCountdown(root) {
    const countdown = root.querySelector('[data-gut-countdown]');
    if (!countdown) return;
    if (countdown.dataset.gutCountdownReady === 'true') return;
    countdown.dataset.gutCountdownReady = 'true';
    const hoursEl = countdown.querySelector('[data-gut-countdown-hours]');
    const minutesEl = countdown.querySelector('[data-gut-countdown-minutes]');
    const secondsEl = countdown.querySelector('[data-gut-countdown-seconds]');
    const expiredEl = root.querySelector('[data-gut-countdown-expired]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    const deadline = new Date(countdown.dataset.gutCountdownDeadline || '2026-06-20T23:59:59');
    const pad = (value) => String(value).padStart(2, '0');

    function render() {
      const remaining = deadline.getTime() - Date.now();
      if (remaining <= 0) {
        countdown.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        return;
      }
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      hoursEl.textContent = String(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
      window.setTimeout(render, 1000);
    }

    render();
  }

  function updateBuybox(box) {
    const mode = box.querySelector('[data-gut-purchase-type]:checked')?.value || 'subscription';
    const options = box.querySelectorAll('.gut-option');
    const refill = box.querySelector('[data-gut-refill]');
    options.forEach((option) => {
      const input = option.querySelector('[data-gut-variant]');
      if (!input) return;
      const save = mode === 'subscription' ? input.dataset.subSave : input.dataset.oneSave;
      const price = mode === 'subscription' ? input.dataset.subPrice : input.dataset.onePrice;
      const comparePrice = input.dataset.comparePrice;
      const copy = option.querySelector('[data-gut-bottles-copy]');
      const priceEl = option.querySelector('[data-gut-price]');
      const comparePriceEl = option.querySelector('[data-gut-compare-price]');
      const bottles = option.querySelector('strong')?.textContent?.match(/\d/)?.[0] || '1';
      const baseCopy = input.dataset.bottlesCopy || '';
      if (copy) {
        if (baseCopy) {
          copy.textContent = baseCopy.match(/Save\s+[^|]+/i)
            ? baseCopy.replace(/Save\s+[^|]+/i, `Save ${save}`)
            : `${baseCopy} | Save ${save}`;
        } else {
          copy.textContent = `${bottles} bottle${bottles === '1' ? '' : 's'} total | Save ${save}`;
        }
      }
      if (priceEl) priceEl.textContent = price;
      if (comparePriceEl && comparePrice) comparePriceEl.textContent = comparePrice;
      option.classList.toggle('is-active', input.checked);
    });
    if (refill) {
      const isSubscription = mode === 'subscription';
      refill.classList.toggle('is-active', isSubscription);
      refill.setAttribute('aria-pressed', String(isSubscription));
    }
    box.classList.toggle('is-onetime', mode === 'onetime');
  }

  async function addToCart(box, button) {
    const mode = box.querySelector('[data-gut-purchase-type]:checked')?.value || 'subscription';
    const selected = box.querySelector('[data-gut-variant]:checked');
    const message = box.querySelector('[data-gut-cart-message]');
    if (!selected) return;
    const defaultLabel = button.dataset.gutAtcLabel || 'Add to Cart';
    const addingLabel = button.dataset.gutAtcAddingLabel || 'Adding...';
    const addedLabel = button.dataset.gutAtcAddedLabel || 'Added to Cart';
    const successMessage = button.dataset.gutCartSuccessMessage || 'Added to cart. <a href="/cart">View cart</a> or continue shopping.';

    const variantId = Number(selected.dataset.variantId);
    if (!variantId) {
      if (message) message.textContent = 'Select a product or enter a fallback variant ID for this bundle.';
      return;
    }

    const item = {
      id: variantId,
      quantity: Math.max(1, Number(selected.dataset.quantity) || 1),
    };
    if (mode === 'subscription' && selected.dataset.sellingPlan) {
      item.selling_plan = Number(selected.dataset.sellingPlan);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.id);
    const payload = { items: [item] };
    if (sections?.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }

    button.disabled = true;
    button.textContent = addingLabel;
    if (message) message.textContent = '';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Unable to add this bundle.');
      }
      button.textContent = addedLabel;
      if (cartDrawer?.renderContents) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
        if (message) message.textContent = '';
      } else if (window.Upcart?.open) {
        window.Upcart.refresh?.();
        window.Upcart.open();
        if (message) message.textContent = '';
      } else if (message) {
        message.innerHTML = successMessage;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      window.Upcart?.refresh?.();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gut-buybox', cartData: data });
      }
    } catch (error) {
      button.textContent = defaultLabel;
      if (message) message.textContent = error.message;
    } finally {
      button.disabled = false;
    }
  }

  function initBuybox(box) {
    if (box.dataset.gutBuyboxReady === 'true') return;
    box.dataset.gutBuyboxReady = 'true';

    box.addEventListener('change', (event) => {
      if (event.target.matches('[data-gut-purchase-type], [data-gut-variant]')) {
        updateBuybox(box);
      }
    });
    box.querySelector('[data-gut-refill]')?.addEventListener('click', () => {
      const currentMode = box.querySelector('[data-gut-purchase-type]:checked')?.value || 'subscription';
      const nextMode = currentMode === 'subscription' ? 'onetime' : 'subscription';
      const nextInput = box.querySelector(`[data-gut-purchase-type][value="${nextMode}"]`);
      if (nextInput) {
        nextInput.checked = true;
        nextInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    box.querySelector('[data-gut-add-to-cart]')?.addEventListener('click', (event) => {
      addToCart(box, event.currentTarget);
    });
    updateBuybox(box);
  }

  function initMobileCarousel(carousel) {
    if (carousel.dataset.gutMobileCarouselReady === 'true') return;
    carousel.dataset.gutMobileCarouselReady = 'true';

    const track = carousel.querySelector('[data-gut-mobile-carousel-track]');
    if (!track) return;
    const realSlides = Array.from(track.querySelectorAll('[data-gut-mobile-carousel-slide]'));
    if (!realSlides.length) return;

    initLoopingTrackCarousel({
      carousel,
      track,
      realSlides,
      viewport: carousel.querySelector('[data-gut-mobile-carousel-viewport]') || carousel.querySelector('.gut-mobile-proof__viewport'),
      prev: carousel.querySelector('[data-gut-mobile-carousel-prev]'),
      next: carousel.querySelector('[data-gut-mobile-carousel-next]'),
      cloneKey: 'gutMobileCarouselClone',
      transitionMs: 250,
    });
  }

  function initAutoCarousel(carousel) {
    if (carousel.dataset.gutAutoCarouselReady === 'true') return;
    carousel.dataset.gutAutoCarouselReady = 'true';

    const track = carousel.querySelector('[data-gut-auto-carousel-track]');
    if (!track) return;
    const realSlides = Array.from(track.querySelectorAll('[data-gut-auto-carousel-slide]'));
    if (!realSlides.length) return;

    initLoopingTrackCarousel({
      carousel,
      track,
      realSlides,
      viewport: carousel.querySelector('[data-gut-auto-carousel-viewport]'),
      cloneKey: 'gutAutoCarouselClone',
      transitionMs: Number(carousel.dataset.gutAutoTransition) || 420,
      autoplayMs: Number(carousel.dataset.gutAutoInterval) || 2800,
    });
  }

  function initMobileLoadMore(button) {
    if (button.dataset.gutMobileLoadMoreReady === 'true') return;
    button.dataset.gutMobileLoadMoreReady = 'true';

    const list = button.closest('.gut-mobile-story__section')?.querySelector('.gut-mobile-review-list');
    if (!list) return;
    const cards = Array.from(list.querySelectorAll('.gut-mobile-review-card'));
    const initialVisible = 4;
    let visible = initialVisible;

    function update() {
      cards.forEach((card, index) => {
        card.hidden = index >= visible;
      });
      button.hidden = visible >= cards.length;
      button.setAttribute('aria-expanded', visible >= cards.length ? 'true' : 'false');
    }

    button.addEventListener('click', () => {
      visible = cards.length;
      update();
    });

    update();
  }

  function initRoot(root) {
    root.querySelectorAll('[data-gut-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-gut-buybox]').forEach(initBuybox);
    root.querySelectorAll('[data-gut-mobile-carousel]').forEach(initMobileCarousel);
    root.querySelectorAll('[data-gut-auto-carousel]').forEach(initAutoCarousel);
    root.querySelectorAll('[data-gut-mobile-load-more]').forEach(initMobileLoadMore);
    initTestimonials(root);
    initCalculator(root);
    initFaq(root);
    initLabel(root);
    initBatch(root);
    initCountdown(root);
  }

  function initAll(scope) {
    if (scope.matches?.('.gut')) {
      initRoot(scope);
    }
    scope.querySelectorAll?.('.gut').forEach(initRoot);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
